import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as PermissionActions from './permissions.action';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../helper/helper.service';
import { SaveState } from '../../models/commonModels';
import { PermissionService } from './permissions.service';
import { PermissionObjectModel, PermissionsListModel } from '../../models/permissions/permissions';

export interface PermissionStateModel {
    Permission: PermissionObjectModel;
    PermissionsList: PermissionsListModel;
  }

@State<PermissionStateModel>({
    name: 'permissionState',
    defaults: {
      Permission: null,
      PermissionsList: null,
    }
  })

  @Injectable()
  export class PermissionState {

    constructor(
      private helperService: HelperService,
      private permissionService: PermissionService,
      private bannerService: BannerService
    ) { }

  @Selector()
  static PermissionsList(state: PermissionStateModel) {
    return state.PermissionsList;
  }


  @Action(PermissionActions.GetRolePermissions)
  getRolePermissions(
    context: StateContext<PermissionStateModel>,
    action: PermissionActions.GetRolePermissions
  ) {

    const errorMessage = 'Błąd pobierania listy uprawnień';

    context.setState(
      patch({
        PermissionsList: null
      })
    );

    this.permissionService.getRolePermissions(action.RoleId, action.isAdmin).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            PermissionsList: ret
          })
        );
        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('PermissionActions.GetRolePermissions', error);

        this.bannerService.error(errorMessage);
      });
  }
}

